import { Component, OnInit } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { SolicitacaoService } from 'app/service/solicitacao/solicitacao.service';
import { MatDialog } from '@angular/material/dialog';
import { ImprimirControleComponent } from 'app/components/solicitacao/imprimir-controle/imprimir-controle.component';
import { ControleComponent } from 'app/components/solicitacao/controle/controle.component';
import { AuthenticationService } from '@alfresco/adf-core';

@Component({
  selector: 'app-devolver-caixas',
  templateUrl: './devolver-caixas.component.html',
  styleUrls: ['./devolver-caixas.component.scss']
})
export class DevolverCaixasComponent implements OnInit {

  result ;
  resultEmRecuperacao;
  loading = false;
  pendenteRecuperacao = [];
  emRecuperacao = [];
  rgInput ;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  logIsvisivel = false;
  logs = [];
  controles = [];
  adm = false;
  acervo = false;
  solicitacao = true;

  constructor(
    private authService: AuthenticationService,
    private service : SolicitacaoService,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar) { }

  ngOnInit() {
    this.carregarPendenteRecuperacao();
  }

  alterarVisualizacaoLog(){
    if(this.logIsvisivel){
      this.logIsvisivel = false;
    }else{
      this.logIsvisivel = true;
    }
  }

  imprimirControle() {
    const dialogRef = this.dialog.open(ImprimirControleComponent, {
      width: '40%',
      data: {tipoSolicitacao: '1'}
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
    });
  }

  selecionarTodos() {
    console.log(this.pendenteRecuperacao);
    this.pendenteRecuperacao.map(el => {
      console.log(el.id);
      this.incluirRGEmRecuperacao(el.rgCaixa);
    });
  }

  listarControles(idsCaixas) {
    this.service.listarControles(idsCaixas).subscribe(data => {
      console.log(data);
      this.controles = data;
    }, err => {
      console.error(err);
    });
  }

  addControle() {
    const dialogRef = this.dialog.open(ControleComponent, {
      width: '70%',
      data: {tipoSolicitacao: 'devolucaoRecipiente'}
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.carregarPendenteRecuperacao();
      console.log(`The dialog was closed - ${result}`);
      console.log(result);
    });
  }

  carregarPendenteRecuperacao(){
    this.loading = true;
    this.service.listarCaixasPendeteDevolucao().subscribe(data=>{
      this.result = data;
      console.log(this.result)
      if(this.result.cod == 200){
        this.pendenteRecuperacao = this.result.result;
        this.loading = false;
        let caixasIds = [];
        this.pendenteRecuperacao.map(el => {
          if (el.idControle !== null) {
            caixasIds.push(el.id);
          }
        });
        this.listarControles(caixasIds);
      }
    })
  }

  carregarEmRecuperacao(){
    let user = localStorage.getItem('APS_USERNAME');
    let obj = {"rgCaixa" : "", username: user};
    this.loading = true;
    this.service.caixasEmDevolucao(obj).subscribe(data=>{
      this.resultEmRecuperacao = data;
      console.log(this.resultEmRecuperacao)
      if(this.resultEmRecuperacao.cod == 200){
        this.emRecuperacao = this.resultEmRecuperacao.result;
        this.loading = false;
      }else {
        this.openSnackBarError(this.resultEmRecuperacao.message)
        this.loading = false;
      }
    })


  }

  rgEmRecuperacao(){
    if(this.rgInput != ""){
      this.incluirRGEmRecuperacao(this.rgInput );
      this.rgInput = "";
    }

  }

  incluirRGEmRecuperacao(rg){
    let user = localStorage.getItem('APS_USERNAME');
    let obj = {"rgCaixa" : rg, username: user};
    this.loading = true;
    this.service.devolverCaixaUnica(obj).subscribe(data=>{
      this.result = data;
      console.log(this.result)
      if(this.result.cod == 200){
        this.openSnackBarSuccess("Caixa RG "+ rg + " em devolução !");
        this.logs.push("Caixa RG "+ rg + " em devolução !");
        this.carregarPendenteRecuperacao();
        this.carregarEmRecuperacao();
      }else if(this.result.cod == 204){
        this.openSnackBarError(this.result.message)
        this.loading = false;
      }
    })

  }

  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }

  recuperarRecipientesUser(){
    let user = localStorage.getItem('APS_USERNAME');
    let obj = {"rgCaixa" : "", username: user};
    this.loading = true;
    this.service.devolverRecipientesUser(obj).subscribe(data=>{
      this.result = data;
      console.log( this.result)
      if(this.result.cod == 200){
        for(let i = 0 ; i < this.result.result.length; i++){
          this.logs.push("Caixa RG "+ this.result.result[i].rgCaixa + " em custódia !");
        }
        this.carregarEmRecuperacao();
        this.carregarPendenteRecuperacao;
        this.openSnackBarSuccess("Caixas devolvidas com sucesso!");

      }else {
        this.openSnackBarError(this.result.message)
        this.loading = false;
      }
    })
  }

}



// WEBPACK FOOTER //
// /app/src/app/devolver-caixas/devolver-caixas.component.ts